(function () {
  'use strict';

  var section = document.querySelector('.bundle-hero');
  if (!section) return;

  var primaryCta = section.querySelector('.bundle-hero__cta-primary');
  if (!primaryCta) return;

  primaryCta.addEventListener('click', function (e) {
    // Graceful fallback: if the participant dialog API is missing,
    // let the anchor's default behavior scroll to #bundle-details.
    if (typeof openCloseDialog !== 'function') return;

    var bundleAtc = document.querySelector('.bundle-details__atc-btn');
    if (!bundleAtc) return; // fallback: native anchor scroll

    e.preventDefault();
    e.stopPropagation(); // Prevent Prestige theme.js smooth-scroll override
    bundleAtc.click();
  });

  var rating = section.querySelector('[data-scroll-to-reviews]');
  if (rating) {
    var scrollToReviews = function () {
      var reviews = document.getElementById('bundle-reviews');
      if (!reviews) return;
      reviews.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    rating.addEventListener('click', scrollToReviews);
    rating.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        scrollToReviews();
      }
    });
  }
})();
